module.exports = __webpack_public_path__ + "assets/img/18.e225f48f.png";